import { documentationActions } from '../../actions/constant';

const {
  SUCCESS_GET_SIGNATURE_ACCESS,
  FAILURE_GET_SIGNATURE_ACCESS,
  REQUEST_GET_SIGNATURE_ACCESS,
  RESET_GET_SIGNATURE_ACCESS,
} = documentationActions;

const intitialstate: object = {
  response: null,
  isGetAccess: false,
  loading: false,
};

export const getSignatureAccessReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case SUCCESS_GET_SIGNATURE_ACCESS: {
      return {
        ...state,
        isGetAccess: true,
        response: action.payload,
        loading: false,
      };
    }

    case FAILURE_GET_SIGNATURE_ACCESS:
      return {
        ...state,
        isGetAccess: false,
        response: action.payload,
        loading: false,
      };

    case REQUEST_GET_SIGNATURE_ACCESS:
      return {
        ...state,
        loading: true,
      };

    case RESET_GET_SIGNATURE_ACCESS:
      return intitialstate;

    default:
      return state;
  }
};
